






import { Component, Vue } from 'vue-property-decorator'
import axios, { AxiosRequestConfig } from "axios"
import api from "../../api/index"

@Component({
  components: {
  },
})

export default class Users extends Vue {
 
}
